import React, { useEffect, useState } from "react";
import CourseService from "../../Api/CourseService";
import { Link } from "react-router-dom";
import "./FounderInfo.css";
// import { useNavigate } from "react-router-dom"; // Removed as not needed for this design

const FounderInfo = () => {

    const [courses, setCourses] = useState([]);
    const courseService = new CourseService();

    useEffect(() => {
        fetchCourses();
    }, []);

    const fetchCourses = async () => {
        try {
            const response = await courseService.GetAllCourseForSale(false);
            if (response?.data?.data) {
                setCourses(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching courses:", error);
        }
    };

    // Calculate statistics safely
    const totalCurrentStudents = Array.isArray(courses)
        ? courses.reduce((total, course) => total + (course.current_students || 0), 0)
        : 0;

    const totalCourses = Array.isArray(courses) ? courses.length : 0;

    const totalMaxStudents = Array.isArray(courses)
        ? courses.reduce((total, course) => total + (course.max_students || 0), 0)
        : 0;


    return (
        <>
            {/* <div className="about-style-2 rbt-section-gapBottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="row about-wrapper align-items-stretch theme-shape">

                                <div className="col-lg-6 col-xl-4">
                                    <div className="rbt-shadow-box">
                                        <img
                                            className="w-100"
                                            src="assets1/images/about/about-12.jpg" // You may need to change this path to your specific image for Venkatesan
                                            alt="Venkatesan"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-xl-8 about-founder">
                                    <div className="section-title">

                                    </div>
                                    <div className="content">
                                        <h4 className="title">
                                            Hi, I'm <span className="theme-gradient">Venkatesan</span>
                                        </h4>
                                        <p className="lead">
                                            <strong>a full-time options trader with 5 years of hands-on experience in the Indian stock market.</strong>
                                        </p>
                                        <p>
                                            <strong>I'm 25 years old and a B.Com graduate who chose trading as a full-time career right after college. Over the years, I've specialized in Nifty options trading, mastering both option buying and option selling. What sets my approach apart is the ability to identify when to buy and when to sell — based on India VIX, market sentiment, and other technical factors.</strong>
                                        </p>
                                        <p>
                                            <strong>But my journey wasn't smooth. Like many aspiring traders, I struggled in the beginning. I attended multiple workshops and courses hoping to learn — but what I found was disappointing. Most of them lacked real mentorship. They were focused on selling courses, not on building real traders.</strong>
                                        </p>
                                        <p>
                                            <strong>That's when I decided to become the kind of mentor</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="rbt-counterup-area bg-gradient-6 rbt-section-gap">
                <div className="container">
                    <div className="row mb--60">
                        <div className="col-lg-12">
                            <div className="section-title text-center">
                                <h2 className="title">
                                    <span className="theme-gradient">What Makes Us</span> Different?
                                </h2>
                                <div className="what-makes-different mt--30">
                                    <ul className="different-points">
                                        <li>
                                            <i className="fas fa-check-circle"></i>
                                            Live market guidance based on current volatility and price action
                                        </li>
                                        <li>
                                            <i className="fas fa-check-circle"></i>
                                            Real trades and real-time decisions — not just recorded theory
                                        </li>
                                        <li>
                                            <i className="fas fa-check-circle"></i>
                                            Capital and risk management-first approach
                                        </li>
                                        <li>
                                            <i className="fas fa-check-circle"></i>
                                            Supportive learning environment for beginners and intermediate traders
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-5">
                        {/* Start Single Counter  */}
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="rbt-counterup style-3">
                                <div className="inner">
                                    <div className="content">
                                        <h2 className="counter">
                                            <span className="odometer" data-count={500}>
                                                {totalCurrentStudents}
                                            </span>
                                        </h2>
                                        <span className="subtitle">Learners &amp; counting</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End Single Counter  */}
                        {/* Start Single Counter  */}
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="rbt-counterup style-3">
                                <div className="inner">
                                    <div className="content">
                                        <h2 className="counter">
                                            <span className="odometer" data-count={800}>
                                                {totalCourses}
                                            </span>
                                        </h2>
                                        <span className="subtitle">Courses Available</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End Single Counter  */}
                        {/* Start Single Counter  */}
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="rbt-counterup style-3">
                                <div className="inner">
                                    <div className="content">
                                        <h2 className="counter">
                                            <span className="odometer" data-count={1000}>
                                                {totalMaxStudents}
                                            </span>
                                        </h2>
                                        <span className="subtitle">Total Seats Available</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End Single Counter  */}
                    </div>
                </div>
            </div>

            <div className="rbt-video-area bg-color-white rbt-section-gapTop" id="about">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <div className="video-popup-wrapper">
                                <img
                                    className="w-100 rbt-radius"
                                    src="https://img.youtube.com/vi/IrMNqSMwtlM/sddefault.jpg"
                                    alt="One Year P&L Proof Video"
                                />
                                <a
                                    className="rbt-btn rounded-player popup-video position-to-top rbtplayer"
                                    href="https://www.youtube.com/watch?v=IrMNqSMwtlM"
                                    target="_blank"
                                >
                                    <span>
                                        <i className="feather-play" />
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                                <div className="section-title text-start">
                                    <h4 className="title">One Year P&L Proof</h4>
                                    <p className="description mt--30">
                                        Watch my detailed one-year trading performance video where I share my actual P&L statements, trading strategies, and key learnings from the market. This transparent approach helps you understand real-world trading results and what to expect from our mentorship program.
                                    </p>
                                    <div className="rbt-feature-wrapper mt--40">
                                        <div className="rbt-feature feature-style-1 align-items-center">
                                            <div className="icon bg-pink-opacity">
                                                <i className="feather-trending-up" />
                                            </div>
                                            <div className="feature-content">
                                                <h6 className="feature-title">Real Trading Results</h6>
                                            </div>
                                        </div>
                                        <div className="rbt-feature feature-style-1 align-items-center">
                                            <div className="icon bg-primary-opacity">
                                                <i className="feather-bar-chart-2" />
                                            </div>
                                            <div className="feature-content">
                                                <h6 className="feature-title">Strategy Breakdown</h6>
                                            </div>
                                        </div>
                                        <div className="rbt-feature feature-style-1 align-items-center">
                                            <div className="icon bg-coral-opacity">
                                                <i className="feather-shield" />
                                            </div>
                                            <div className="feature-content">
                                                <h6 className="feature-title">
                                                    Risk Management Insights
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="rbt-callto-action-area" id="PL">
                <div className="container">
                    <div className="rbt-callto-action rbt-cta-default style-4 variation-2">
                        <div className="custom-cta-layout">
                            <div className="thumbnail">
                                <img
                                    className="w-100"
                                    src="assets1/images/sensibull-logo.png"
                                    alt="Sensibull Verified P&L"
                                />
                            </div>
                            <div className="cta-content-area">
                                <div className="inner">
                                    <div className="content text-left">
                                        <h2 className="title theme-gradient">
                                            Check My Verified Trading Performance
                                        </h2>
                                        <div className="call-to-btn text-start mt--30">
                                            <a 
                                                className="rbt-btn btn-gradient hover-icon-reverse" 
                                                href="https://web.sensibull.com/verified-pnl/accustomed-marimba/XMqUTUG2fLRpRU"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <span className="icon-reverse-wrapper">
                                                    <span className="btn-text">View Verified P&L</span>
                                                    <span className="btn-icon">
                                                        <i className="feather-arrow-right" />
                                                    </span>
                                                    <span className="btn-icon">
                                                        <i className="feather-arrow-right" />
                                                    </span>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default FounderInfo;
